import Request from './request';

/**
 * Типы отчётов (должны совпадать с backend)
 */
export const REPORT_TYPES = {
  // Общие отчёты
  GENERAL_CARD: 'general_card',
  GENERAL_OPERATOR_TABLE: 'general_operator_table',
  GENERAL_QUEUE_TABLE: 'general_queue_table',
  GENERAL_LINE_CHART: 'general_line_chart',
  GENERAL_LINE_CHART_CLOSE: 'general_line_chart_close',
  GENERAL_LINE_CHART_NONE: 'general_line_chart_none',
  GENERAL_BAR_CHART: 'general_bar_chart',
  GENERAL_AVG_WAIT_TIME: 'general_avg_wait_time',
  GENERAL_AVG_PROC_TIME: 'general_avg_proc_time',
  GENERAL_DOUGHNUT_QUEUE: 'general_doughnut_queue',

  // Графические отчёты
  GRAPHIC_MAIN: 'graphic_main',
  GRAPHIC_DOUGHNUT_PROC: 'graphic_doughnut_proc',
  GRAPHIC_DOUGHNUT_WAIT: 'graphic_doughnut_wait',
  GRAPHIC_DOUGHNUT_QUEUE: 'graphic_doughnut_queue',

  // Отчёты по операторам
  OPERATOR_REPORT: 'operator_report',

  // Отчёты по талонам
  TICKET_REPORT: 'ticket_report',
  TICKET_REPORT_EXPAND: 'ticket_report_expand',
  TICKET_RESTORE: 'ticket_restore',

  // Отчёты по оценкам
  MARK_REPORT: 'mark_report',

  // Линейные отчёты
  LINE_REPORT: 'line_report',

  // Контроль качества
  QUALITY_SURVEY: 'quality_survey',
  QUALITY_APPEALS: 'quality_appeals',

  // Справочники
  OPERATOR_LIST: 'operator_list',
  QUEUE_LIST: 'queue_list',
  WORKPLACE_LIST: 'workplace_list',
  ZONE_LIST: 'zone_list',
};

/**
 * Выполнить типизированный отчёт
 * @param {string} reportType - тип отчёта из REPORT_TYPES
 * @param {object} params - параметры отчёта (startTime, endTime, и т.д.)
 * @returns {Promise<{dataObjects: Array, query: string}>}
 */
export async function executeReport(reportType, params = {}) {
  try {
    const res = await Request('/api/sql-reports/report', 'get', {
      reportType,
      ...params,
    });

    const dataObjects = [];
    const responseData = res.data;

    // Проверяем, есть ли columnNames и data (новый формат)
    if (responseData.columnNames && Array.isArray(responseData.data)) {
      const { columnNames, data: answerData } = responseData;

      // Преобразуем массивы в объекты с именованными полями
      // И сохраняем также доступ по индексам для обратной совместимости
      answerData.forEach((row) => {
        const rElem = {};
        row.forEach((value, idx) => {
          rElem[columnNames[idx]] = value;
          rElem[idx] = value; // Добавляем доступ по индексу
        });
        dataObjects.push(rElem);
      });
    } else if (Array.isArray(responseData.data)) {
      // Старый формат - просто массив объектов
      responseData.data.forEach((v) => {
        dataObjects.push({ ...v });
      });
    }

    // Для обратной совместимости возвращаем query (теперь это описание)
    const query = `Тип отчёта: ${reportType}, параметры: ${JSON.stringify(params)}`;

    return { dataObjects, query };
  } catch (error) {
    console.error('Ошибка выполнения отчёта:', error);
    throw error;
  }
}

/**
 * Получить список доступных типов отчётов
 * @returns {Promise<Array>}
 */
export async function getReportTypes() {
  try {
    const res = await Request('/api/sql-reports/types', 'get');
    return res.data.data;
  } catch (error) {
    console.error('Ошибка получения типов отчётов:', error);
    throw error;
  }
}

/**
 * Хелперы для частых случаев
 */

// Отчёты с временным периодом
export function executeTimeRangeReport(reportType, startTime, endTime) {
  return executeReport(reportType, { startTime, endTime });
}

// Справочники (без параметров)
export function executeDictionaryReport(reportType) {
  return executeReport(reportType, {});
}

// Отчёты контроля качества
export function executeQualityReport(reportType, sessionDataId) {
  return executeReport(reportType, { sessionDataId });
}

export default executeReport;
